import React from 'react';

export type ButtonIconPosition = 'left' | 'right';

export type ButtonIconSize = 'small' | 'large';

export type ButtonIconLabelProps = {
  SVGIcon: any;
  iconPosition: ButtonIconPosition;
  iconSize: ButtonIconSize;
  children: React.ReactNode;
};

export default function ButtonIconLabel({
  SVGIcon,
  iconPosition,
  iconSize,
  children,
}: ButtonIconLabelProps) {
  const size = iconSize === 'large' ? '16px' : '10px';

  // TODO: define SVG size using Tailwind
  return (
    <div className="flex items-center justify-center">
      {iconPosition === 'left' && (
        <SVGIcon height={size} width={size} className="mr-[4px] shrink-0" />
      )}
      <div>{children}</div>
      {iconPosition === 'right' && (
        <SVGIcon height={size} width={size} className="ml-[4px] shrink-0" />
      )}
    </div>
  );
}
